import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Header, Tab } from 'semantic-ui-react';
import BillingOverview from './components/BillingOverview';
import BillingConfigList from './components/BillingConfigList';

const ChannelBilling = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const panes = [
    {
      menuItem: t('channel_billing.tab_overview', '账单总览'),
      render: () => (
        <Tab.Pane>
          <BillingOverview />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t('channel_billing.tab_config', '账单配置'),
      render: () => (
        <Tab.Pane>
          <BillingConfigList />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <Container fluid style={{ padding: '20px' }}>
      <Header as='h2'>{t('channel_billing.title', '渠道账单总览')}</Header>
      <Tab
        panes={panes}
        activeIndex={activeTab}
        onTabChange={(e, { activeIndex }) => setActiveTab(activeIndex)}
      />
    </Container>
  );
};

export default ChannelBilling;
